export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-battery-full-6ff6e5cd098ac3fa57cd4ed72b2c0a23.svg";